/* RAO_COLLECTION_EXPERIENCE_SCRIPT_V1 */
(() => {
  if (window.RAOCollectionExperienceV1) return;
  window.RAOCollectionExperienceV1 = true;

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const stackedLayout = window.matchMedia("(max-width: 1199px)");
  const closeTimers = new WeakMap();

  const triggerFor = (panel) =>
    document.querySelector(
      `[data-rao-collection-advisor-trigger][aria-controls="${CSS.escape(panel.id)}"]`,
    );

  const setGeometry = (trigger, panel) => {
    const grid = trigger.closest(".product-list");
    if (!grid) return;
    grid.classList.add("rao-collection-advisor-grid");

    if (stackedLayout.matches) {
      panel.style.removeProperty("--rao-advisor-panel-top");
      panel.style.removeProperty("--rao-advisor-panel-left");
      panel.style.removeProperty("--rao-advisor-panel-width");
      panel.style.removeProperty("--rao-advisor-panel-height");
      return;
    }

    const gridRect = grid.getBoundingClientRect();
    const triggerRect = trigger.getBoundingClientRect();
    panel.style.setProperty(
      "--rao-advisor-panel-top",
      `${triggerRect.top - gridRect.top}px`,
    );
    panel.style.setProperty(
      "--rao-advisor-panel-left",
      `${triggerRect.left - gridRect.left}px`,
    );
    panel.style.setProperty(
      "--rao-advisor-panel-width",
      `${gridRect.right - triggerRect.left}px`,
    );
    panel.style.setProperty(
      "--rao-advisor-panel-height",
      `${triggerRect.height}px`,
    );
  };

  const closePanel = (panel, restoreFocus = false) => {
    const trigger = triggerFor(panel);
    if (trigger) trigger.setAttribute("aria-expanded", "false");
    panel.classList.remove("is-open");

    window.clearTimeout(closeTimers.get(panel));
    const timer = window.setTimeout(
      () => {
        if (!panel.classList.contains("is-open")) panel.hidden = true;
      },
      reduceMotion.matches ? 0 : 290,
    );
    closeTimers.set(panel, timer);

    if (restoreFocus && trigger) {
      trigger.focus({ preventScroll: true });
    }
  };

  const closeOtherPanels = (currentPanel) => {
    document
      .querySelectorAll("[data-rao-collection-advisor-panel].is-open")
      .forEach((panel) => {
        if (panel !== currentPanel) closePanel(panel);
      });
  };

  const openPanel = (trigger, panel, moveFocus = false) => {
    closeOtherPanels(panel);
    window.clearTimeout(closeTimers.get(panel));
    panel.hidden = false;
    trigger.setAttribute("aria-expanded", "true");
    setGeometry(trigger, panel);
    panel.getBoundingClientRect();
    panel.classList.add("is-open");

    if (moveFocus) {
      panel
        .querySelector("[data-rao-collection-advisor-close]")
        ?.focus({ preventScroll: true });
    }

    if (stackedLayout.matches) {
      window.setTimeout(
        () => {
          panel.scrollIntoView({
            behavior: reduceMotion.matches ? "auto" : "smooth",
            block: "start",
          });
        },
        reduceMotion.matches ? 0 : 120,
      );
    }
  };

  const toggleFromTrigger = (trigger, moveFocus = false) => {
    const panelId = trigger.getAttribute("aria-controls");
    const panel = panelId && document.getElementById(panelId);
    if (!panel) return;

    if (trigger.getAttribute("aria-expanded") === "true") {
      closePanel(panel);
    } else {
      openPanel(trigger, panel, moveFocus);
    }
  };

  document.addEventListener("click", (event) => {
    const closeButton = event.target.closest(
      "[data-rao-collection-advisor-close]",
    );
    if (closeButton) {
      const panel = closeButton.closest("[data-rao-collection-advisor-panel]");
      if (panel) closePanel(panel, true);
      return;
    }

    const trigger = event.target.closest(
      "[data-rao-collection-advisor-trigger]",
    );
    if (trigger) {
      toggleFromTrigger(trigger, event.detail === 0);
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    const panel = document.querySelector(
      "[data-rao-collection-advisor-panel].is-open",
    );
    if (panel) closePanel(panel, true);
  });

  window.addEventListener(
    "resize",
    () => {
      document
        .querySelectorAll(
          '[data-rao-collection-advisor-trigger][aria-expanded="true"]',
        )
        .forEach((trigger) => {
          const panelId = trigger.getAttribute("aria-controls");
          const panel = panelId && document.getElementById(panelId);
          if (panel) setGeometry(trigger, panel);
        });
    },
    { passive: true },
  );
})();
